/** Canonical Material Symbols Outlined names used across Kilo. */
export const MATERIAL_ICONS = {
  exercise: 'exercise',
  selfImprovement: 'self_improvement',
  sportsMartialArts: 'sports_martial_arts',
  vitalSigns: 'vital_signs',
  watchScreentime: 'watch_screentime',
} as const

export type MaterialIconName = (typeof MATERIAL_ICONS)[keyof typeof MATERIAL_ICONS]

/** PUA codepoints for icons that must not fall back to ligature text. */
const OUTLINED_CODEPOINTS: Partial<Record<string, string>> = {
  [MATERIAL_ICONS.exercise]: '\uF6E6',
}

export function materialIconGlyph(name: string): string {
  return OUTLINED_CODEPOINTS[name] ?? name
}
